import { InterfaceSettings } from './contract-notice-dto';
import { I18nData } from './plyca-dtos';

export class DashBoard {
  public id: string;
  public filters: InterfaceSettings;
  public profiles: string;
  public columns: Array<DashboardColumn> = [];
  public descriptionKey: string;
  public modules: Array<string> = [];

  getColumnsNumber(): number {
    return this.columns.length;
  }
}

export class DashboardColumn {
  public id: string;
  public columnNumber: number;
  public components: Array<string> = [];
}

export class WidgetDefinition {
  constructor(
    public id: string,
    public type: string,
    public attributeId: string,
    public attributeParams: Array<any>,
    public titleKey: I18nData,
    public descriptionKey: I18nData,
    public title: string,
    public description: string,
    public opts?: any
  ) { }
}

export class AvailableWidgets {
  public static readonly WIDGET = 'widget';
  public static readonly CHART = 'chart';
  public static readonly TABLE = 'table';
  public static readonly FAVOURITES = 'favourites';
  public static readonly AUDITUSER = 'auditUser';
  public static readonly TASKCOUNT = 'taskCount';
  public static readonly SESSIONCOUNT = 'sessionCount';
  public static readonly SYSTIME = 'sysTime';
  public static readonly PROCUREMENT_COMMITTEE_TASKS =
    'procurementCommitteeTasks';

  // private static availableWidgets: Array<WidgetDefinition> = [
  //   new WidgetDefinition(
  //     'WD_CH_TIPOTAREA',
  //     AvailableWidgets.CHART,
  //     'DASHBOARD_CHART_TIPOTAREA',
  //     new I18nData('DashBoard.WD_CH_TIPOTAREA'),
  //     new I18nData('DashBoard.WD_CH_TIPOTAREA_DES'),
  //     '',
  //     '',
  //     {
  //       link: 'tasks',
  //       legend: true,
  //       linkParamName: 'TIPO_TAREA',
  //       layoutClass: 'drag-widget col-12 col-sm-4 col-lg-3'
  //     }
  //   ),
  //   new WidgetDefinition(
  //     'WD_CH_EXPPROCONTRA',
  //     AvailableWidgets.CHART,
  //     'DASHBOARD_CHART_EXPPROCONTRA',
  //     new I18nData('DashBoard.WD_CH_EXPPROCONTRA'),
  //     new I18nData('DashBoard.WD_CH_EXPPROCONTRA_DES'),
  //     '',
  //     '',
  //     {
  //       link: 'dossiersView/EXP',
  //       legend: true,
  //       linkParamName: 'TIPO_PROCEDIMIENTO',
  //       layoutClass: 'drag-widget col-12 col-sm-4 col-lg-3'
  //     }
  //   ),
  //   //		new WidgetDefinition ('WD_WD_NUMTAREAS', AvailableWidgets.WIDGET, 'DASHBOARD_WG_NUMTAREAS', 'Tareas pendientes', 'Número de tareas en los buzones del usuario', {link: 'tasks'}),
  //   //		new WidgetDefinition ('WD_WD_NUMFIRMAS', AvailableWidgets.WIDGET, 'DASHBOARD_WG_NUMFIRMAS', 'Firmas pendientes', 'Número de documentos pendientes de firma por parte del usuario', {link: 'tasks', linkParamName: 'TIPO_TAREA', linkParamValue: 'Firma Masiva'}),
  //   new WidgetDefinition(
  //     'WD_FV_FAVOURITES',
  //     AvailableWidgets.FAVOURITES,
  //     '',
  //     new I18nData('DashBoard.WD_FV_FAVOURITES'),
  //     new I18nData('DashBoard.WD_FV_FAVOURITES_DES'),
  //     '',
  //     '',
  //     {
  //       layoutClass: 'drag-widget col-12 col-sm-4 col-lg-3'
  //     }
  //   ),
  //   new WidgetDefinition(
  //     'WD_AU_AUDITUSER',
  //     AvailableWidgets.AUDITUSER,
  //     '',
  //     new I18nData('DashBoard.WD_AU_AUDITUSER'),
  //     new I18nData('DashBoard.WD_AU_AUDITUSER_DES'),
  //     '',
  //     '',
  //     {
  //       layoutClass: 'drag-widget col-12 col-sm-4 col-lg-3',
  //       estilos: 'col-12 col-sm-4 col-lg-3'
  //     }
  //   ),
  //   new WidgetDefinition(
  //     'WD_CH_EXPPORANNO',
  //     AvailableWidgets.CHART,
  //     'DASHBOARD_CHART_EXPPORANNO',
  //     new I18nData('DashBoard.WD_CH_EXPPORANNO'),
  //     new I18nData('DashBoard.WD_CH_EXPPORANNO_DES'),
  //     '',
  //     '',
  //     {
  //       chartType: 'bar',
  //       legend: false,
  //       layoutClass: 'drag-widget col-12 col-sm-4 col-lg-3'
  //     }
  //   ),
  //   new WidgetDefinition(
  //     'WD_CH_EXPPORANNO2',
  //     AvailableWidgets.CHART,
  //     'DASHBOARD_CHART_EXPPORANNO',
  //     new I18nData('DashBoard.WD_CH_EXPPORANNO2'),
  //     new I18nData('DashBoard.WD_CH_EXPPORANNO2_DES'),
  //     '',
  //     '',
  //     {
  //       chartType: 'line',
  //       legend: false,
  //       layoutClass: 'drag-widget col-12 col-sm-4 col-lg-3'
  //     }
  //   ),
  //   new WidgetDefinition(
  //     'WD_TB_EXPPORANNO2',
  //     AvailableWidgets.TABLE,
  //     'DASHBOARD_CHART_EXPPORANNO',
  //     new I18nData('DashBoard.WD_CH_EXPPORANNO2'),
  //     new I18nData('DashBoard.WD_CH_EXPPORANNO2_DES'),
  //     '',
  //     '',
  //     {
  //       cabeceras: ['Año', 'Nº de expedientes'],
  //       columnas: ['DESCRIPTION', 'CUENTA'],
  //       layoutClass: 'drag-widget col-12 col-sm-4 col-lg-3'
  //     }
  //   ),
  //   new WidgetDefinition(
  //     'WD_TB_ESTADOS',
  //     AvailableWidgets.TABLE,
  //     'GG_ESTADOS_OCULTAN_BOTONDEVOLVER',
  //     new I18nData('DashBoard.WD_TB_ESTADOS'),
  //     new I18nData('DashBoard.WD_TB_ESTADOS_DES'),
  //     '',
  //     '',
  //     {
  //       cabeceras: ['ESTADO'],
  //       columnas: ['TIPOESTADOID'],
  //       layoutClass: 'drag-widget col-12 col-sm-4 col-lg-3'
  //     }
  //   ),
  //   new WidgetDefinition(
  //     'WD_TC_NUMTAREAS',
  //     AvailableWidgets.TASKCOUNT,
  //     'ATRID',
  //     new I18nData('DashBoard.WD_TC_NUMTAREAS'),
  //     new I18nData('DashBoard.WD_TC_NUMTAREAS_DES'),
  //     '',
  //     '',
  //     {
  //       link: 'tasks',
  //       linkParamName: 'type',
  //       linkParamValue: '',
  //       estilos: 'style1 bg-azul1',
  //       icon: 'fa-inbox',
  //       layoutClass: 'drag-widget col-12 col-sm-4 col-lg-3',
  //       title: '',
  //       description: ''
  //     }
  //   ),
  //   new WidgetDefinition(
  //     'WD_TC_NUMFIRMAS',
  //     AvailableWidgets.TASKCOUNT,
  //     'ATRID',
  //     new I18nData('DashBoard.WD_TC_NUMFIRMAS'),
  //     new I18nData('DashBoard.WD_TC_NUMFIRMAS_DES'),
  //     '',
  //     '',
  //     {
  //       link: 'tasks',
  //       linkParamName: 'type',
  //       linkParamValue: 'Sign',
  //       estilos: 'style1 bg-warning',
  //       icon: 'fa-file-signature',
  //       layoutClass: 'drag-widget col-12 col-sm-4 col-lg-3'
  //     }
  //   ),
  //   new WidgetDefinition(
  //     'WD_TC_NUMMENSAJES',
  //     AvailableWidgets.TASKCOUNT,
  //     'ATRID',
  //     new I18nData('DashBoard.WD_TC_NUMMENSAJES'),
  //     new I18nData('DashBoard.WD_TC_NUMMENSAJES_DES'),
  //     '',
  //     '',
  //     {
  //       link: 'tasks',
  //       linkParamName: 'type',
  //       linkParamValue: 'Warning',
  //       estilos: 'style1 bg-info',
  //       icon: 'fa-comment',
  //       layoutClass: 'drag-widget col-12 col-sm-4 col-lg-3'
  //     }
  //   ),
  //   new WidgetDefinition(
  //     'WD_TC_ULTIMOSEXPS',
  //     AvailableWidgets.FAVOURITES,
  //     '',
  //     new I18nData('DashBoard.WD_TC_ULTIMOSEXPS'),
  //     new I18nData('DashBoard.WD_TC_ULTIMOSEXPS_DES'),
  //     '',
  //     '',
  //     { type: 'lastAccessed' }
  //   ),
  //   new WidgetDefinition(
  //     'WD_TC_EXPSFAVORITOS',
  //     AvailableWidgets.FAVOURITES,
  //     '',
  //     new I18nData('DashBoard.WD_TC_EXPSFAVORITOS'),
  //     new I18nData('DashBoard.WD_TC_EXPSFAVORITOS_DES'),
  //     '',
  //     '',
  //     { type: 'favourites' }
  //   ),
  //   new WidgetDefinition(
  //     'WD_TC_PERS_DOSSIERS',
  //     AvailableWidgets.FAVOURITES,
  //     'TEST_LIST_DOSSIERS',
  //     new I18nData('DashBoard.WD_TC_PERS_DOSSIERS'),
  //     new I18nData('DashBoard.WD_TC_PERS_DOSSIERS_DES'),
  //     '',
  //     '',
  //     { type: 'attribute', layoutClass: 'drag-widget col-12' }
  //   ),
  //   new WidgetDefinition(
  //     'WD_PROCUREMENT_COMMITTEE_TASKS',
  //     AvailableWidgets.PROCUREMENT_COMMITTEE_TASKS,
  //     '',
  //     new I18nData('DashBoard.WD_PROCUREMENT_COMMITTEE_TASKS'),
  //     new I18nData('DashBoard.WD_PROCUREMENT_COMMITTEE_TASKS_DES'),
  //     '',
  //     '',
  //     { layoutClass: 'drag-widget col-12' }
  //   )
  // ];
  static translationService: any;

  // static getAvailableWidgets(): Array<WidgetDefinition> {
  //   return AvailableWidgets.availableWidgets;
  // }

  // static getWidgetById(id: string): WidgetDefinition {
  //   return AvailableWidgets.getAvailableWidgets().filter(x => x.id === id)[0];
  // }
}

export class DefaultDashboards {
  static getDefaultDashboards(): Array<DashBoard> {
    let ret: Array<DashBoard> = [];

    // Layout
    let db: DashBoard = new DashBoard();
    db.id = 'DashBoard 1';

    // ***************** col 1
    let col: DashboardColumn = new DashboardColumn();
    col.id = 'columna 1';
    col.columnNumber = 1;
    col.components.push('WD_TC_NUMTAREAS');
    col.components.push('WD_TC_NUMFIRMAS');
    col.components.push('WD_TC_NUMMENSAJES');

    db.columns.push(col);

    let col2: DashboardColumn = new DashboardColumn();
    col2.components.push('WD_TC_EXPSFAVORITOS');
    col2.components.push('WD_TC_ULTIMOSEXPS');
    db.columns.push(col2);

    // ***************** col 2
    let col1: DashboardColumn = new DashboardColumn();
    col1.id = 'columna 2';
    col1.columnNumber = 2;
    col1.components.push('WD_AU_AUDITUSER');
    col1.components.push('WD_TC_PERS_DOSSIERS');

    db.columns.push(col1);

    // ***************** col 3
    /*
       col.components.push('WD_TC_NUMTAREAS');
col.components.push('WD_TC_NUMFIRMAS');
col.components.push('WD_TC_NUMMENSAJES');
col.components.push('WD_AU_AUDITUSER');
col.components.push('WD_TC_EXPSFAVORITOS');
col.components.push('WD_CH_EXPPROCONTRA');
col.components.push('WD_CH_EXPPORANNO2');
col.components.push('WD_TC_ULTIMOSEXPS');*/
    let col3: DashboardColumn = new DashboardColumn();
    col3.id = 'columna 3';
    col3.columnNumber = 3;

    col3.components.push('WD_CH_EXPPROCONTRA');
    col3.components.push('WD_CH_EXPPORANNO2');

    db.columns.push(col3);

    ret.push(db);

    db = new DashBoard();
    db.id = 'DashBoard 2';
    col = new DashboardColumn();
    col.id = 'columna 1';
    col.columnNumber = 1;
    col.components.push('WD_TB_EXPPORANNO2');
    col.components.push('WD_AU_AUDITUSER');
    db.columns.push(col);
    ret.push(db);

    return ret;
  }

  static getProcurementCommitteeDashboards(): Array<DashBoard> {
    let ret: Array<DashBoard> = [];

    let db: DashBoard = new DashBoard();
    db.id = 'DashBoard 1';
    let col: DashboardColumn = new DashboardColumn();
    col.id = 'columna 1';
    col.columnNumber = 1;
    col.components.push('WD_PROCUREMENT_COMMITTEE_TASKS');
    db.columns.push(col);
    ret.push(db);

    return ret;
  }
}
